import { NumericDomain, NumericRange, ScaleType, AriosityDirection } from './types'
import { MARGINS, SCALES } from './constants'

export function computeScales(
  scatterWidth: number,
  scatterHeight: number,
  scaleType: ScaleType,
  xDomain: NumericDomain,
  yDomain: NumericDomain,
  xDomainGreater: NumericDomain,
  yDomainGreater: NumericDomain
) {
  const { function: scaleFn } = SCALES[scaleType]
  const xRange = [MARGINS.left, MARGINS.left + scatterWidth] as NumericRange
  const yRange = [MARGINS.top + scatterHeight, MARGINS.top] as NumericRange

  // x scale with domain updated based on x axis handlers
  const xScale = scaleFn().domain(xDomain).range(xRange)

  // x scale with original greater domain
  const xScaleScrollbar = scaleFn().domain(xDomainGreater).range(xRange)

  const xUnknownValue = 0
  xScale.unknown(xUnknownValue)
  xScaleScrollbar.unknown(xUnknownValue)

  // y scale with domain updated based on y axis handlers
  const yScale = scaleFn().domain(yDomain).range(yRange)

  // y scale with original greater domain
  const yScaleScrollbar = scaleFn().domain(yDomainGreater).range(yRange)
  const yUnknownValue = 0
  yScale.unknown(yUnknownValue)
  yScaleScrollbar.unknown(yUnknownValue)

  return {
    xScale,
    yScale,
    xScaleScrollbar,
    yScaleScrollbar,
  }
}

export function expandDirection(oldRange: NumericRange, newRange: NumericRange): AriosityDirection {
  const [oMin, oMax] = oldRange
  const [nMin, nMax] = newRange
  if (nMin < oMin && nMax > oMax) {
    return 'both'
  } else if (nMin < oMin) {
    return 'min'
  } else {
    return 'max'
  }
}

/**
 * Expands the extremes of range by a percentage defined by ariosity.
 * @param range
 * @param ariosity
 */
export function expandRange(
  range: NumericRange,
  ariosity: NumericRange,
  direction?: AriosityDirection
) {
  const dir = direction || 'both'
  const span = range[1] - range[0]
  if (dir === 'min') {
    return [range[0] - span * ariosity[0], range[1]]
  } else if (dir === 'max') {
    return [range[0], range[1] + span * ariosity[1]]
  } else {
    return [range[0] - span * ariosity[0], range[1] + span * ariosity[1]]
  }
}
